module.exports = __webpack_public_path__ + "static/scale-model-of-mary-tyler-moore-statue-in-minneapolis-minnesota-a5c422a14ca6488f30449a788de89101.png";